import { FormIcon, TableIcon } from '@faro/icons';
import React, { createRef, RefObject } from 'react';

export interface Section {
    id: string;
    ref: RefObject<HTMLDivElement | null>;
    label: string;
    icon: React.ReactElement;
}

export const spacePageSectionsData: Section[] = [
    {
        id: 'general-information',
        ref: createRef<HTMLDivElement | null>(),
        label: 'General Information',
        icon: <FormIcon />,
    },
    {
        id: 'optimization-reports',
        ref: createRef<HTMLDivElement | null>(),
        label: 'Optimization Reports',
        icon: <TableIcon />,
    },
    {
        id: 'study-definitions',
        ref: createRef<HTMLDivElement | null>(),
        label: 'Study Definitions',
        icon: <TableIcon />,
    },
];

export function getVisibleSpacePageSections(protocolOptimizationEnabled: boolean): Section[] {
    return spacePageSectionsData.filter(
        section => section.id !== 'optimization-reports' || protocolOptimizationEnabled
    );
}
